module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/dark/long-down-90baf81e5a451ee01e128c19bb34182e.png";